/*
 * Upgrade -- the product photo gallery. 7 Oct 2026 (caldwell-theme,
 * berkane-shopify-arch, matsuda-catalogue). Build note:
 * 2026-10-06_lynkrs-tech-fixes/pdp-gallery-7oct/GALLERY.md
 *
 * Omar, 7 Oct: "fix it because they're gonna upload everything from the
 * product page so make sure everything is working perfectly". The content
 * team uploads each phone's photos in Shopify admin; this file runs the
 * gallery those photos make on the product page, on both product routes:
 *
 *   /products/<handle>  sections/upgrade-product.liquid prints the photos
 *                       (each slide and thumbnail carries its colour, from
 *                       snippets/upgrade-photo.liquid) and loads this file;
 *   /pages/device       assets/upgrade-pdp.js builds the same markup here
 *                       from the product's own /products/<handle>.js
 *                       (UpgradeGallery.fromProduct), with classify() below.
 *
 * Nothing here runs on a phone with no photo: that page keeps its drawn
 * render, exactly as before. No price, no variant, no cart line is read or
 * written here; assets/upgrade-pdp.js tells the gallery which colour is on
 * screen (UpgradeGallery.setColour) and that is all the two share.
 *
 * THE RULES (the same as snippets/upgrade-photo.liquid; tests/gallery.test.js
 * runs both on the same fixtures and fails if they ever disagree):
 *   classify()  which colour each photo shows: the variant image of one
 *               colour; else the alt text starts with the colour (or its
 *               first word is a word only that colour has); else, for an
 *               image, the file name contains the colour (or one of its
 *               words is a word only that colour has). Longest name wins.
 *               A "word" is also two neighbouring words joined (jet-black
 *               = jetblack), and grey reads as gray (check D8, 7 Oct).
 *               No match, or no Colour option: a general photo. 3D models
 *               are never shown.
 *   setFor()    the photos shown for a colour: its own (admin order), then
 *               the general ones; none of its own: the general ones;
 *               neither: the first photo.
 *   pickFor()   the one image a card or the cart shows: the first image of
 *               that colour, else the first general image, else the first.
 *
 * The gallery: one large photo at a time on a white plate, thumbnails of the
 * colour's photos (a scrolling row on a phone, a column from 990px; real
 * buttons, the current one marked aria-current), swipe between photos (the
 * track is a native scroll-snap strip, so it follows the page direction on
 * /ar), tap or click a photo to open it large (a <dialog>: close button,
 * previous / next, Escape, arrow keys, swipe), Shopify videos play in place,
 * a YouTube or Vimeo video loads its player only when asked to play. Words
 * come from the section (data-ug-gal-words, translated there); English is
 * the fallback.
 */
(function (root, factory) {
  'use strict';
  var api = factory(root);
  if (typeof module === 'object' && module.exports) { module.exports = api; }
  if (root && root.document && !root.UpgradeGallery) {
    root.UpgradeGallery = api;
    api.boot();
  }
})(typeof window !== 'undefined' ? window : null, function (win) {
  'use strict';

  /* ---- the colour rules (pure; also run by node in the tests) ---------- */

  // The characters left out when two names are compared: space - _ . , ' ( ) / & +
  var PUNCT = /[ \-_.,'()\/&+]/g;
  var SPLIT = /[\s\-_.,'()\/&+]+/;
  function str(v) { return v == null ? '' : String(v); }
  // Lower case, and "grey" read as "gray" (the colour lists spell it Gray;
  // a file named titanium-grey.webp is that colour). Check D8, 7 Oct 2026.
  function canon(s) { return str(s).toLowerCase().replace(/grey/g, 'gray'); }
  function norm(s) { return canon(s).replace(PUNCT, ''); }
  function words(s) { return canon(s).split(SPLIT).filter(function (w) { return w !== ''; }); }
  function uniq(list) { return list.filter(function (x, i) { return list.indexOf(x) === i; }); }
  // Each word, then it joined to the word before it: jet-black.webp gives
  // jet, black, jetblack, so a colour the list spells as one word (Titanium
  // Jetblack) is found before a shorter one (Titanium Black). Check D8.
  function withPairs(list) {
    var out = [];
    list.forEach(function (t, i) { out.push(t); if (i > 0) { out.push(list[i - 1] + t); } });
    return out;
  }
  // A file name without its folder, its ?query and its extension.
  function fileBase(src) {
    var s = str(src).split('?')[0];
    s = s.slice(s.lastIndexOf('/') + 1);
    var dot = s.lastIndexOf('.');
    if (dot !== -1 && dot < s.length - 1) { s = s.slice(0, dot); }
    return s;
  }
  function isImage(type) { return !type || type === 'image'; }

  // colours: the option's values in option order. media: [{ id, type, alt, src }]
  // in admin order. variantImages: [{ mediaId, colour }], one per variant that
  // has an image. Returns one class per media item: the colour, or '' (general).
  function classify(colours, media, variantImages) {
    var names = (colours || []).map(function (c) { return str(c).trim(); });
    var info = names.map(function (name) {
      return { name: name, n: norm(name), ws: uniq(words(name).filter(function (w) { return w.length >= 3; })) };
    });
    info.forEach(function (c) {
      c.uw = c.ws.filter(function (w) {
        return info.filter(function (o) { return o.ws.indexOf(w) !== -1; }).length === 1;
      });
    });
    var vi = variantImages || [];
    return (media || []).map(function (m) {
      if (!names.length || m.type === 'model') { return ''; }
      var best = -1;
      var blen = 0;
      // 1. the variant image of exactly one colour
      var r1 = '';
      var mixed = false;
      vi.forEach(function (v) {
        if (v && v.mediaId != null && String(v.mediaId) === String(m.id)) {
          var c = str(v.colour).trim();
          if (r1 === '') { r1 = c; } else if (r1 !== c) { mixed = true; }
        }
      });
      if (r1 !== '' && !mixed) { best = names.indexOf(r1); }
      function wordTier(tokens) {
        tokens.forEach(function (t) {
          info.forEach(function (c, k) {
            c.uw.forEach(function (w) {
              if (w.length > blen && t.slice(0, w.length) === w && /^[0-9]*$/.test(t.slice(w.length))) { best = k; blen = w.length; }
            });
          });
        });
      }
      // 2. the alt text
      if (best === -1) {
        var alt = str(m.alt).trim();
        var a = norm(alt);
        if (a !== '') {
          info.forEach(function (c, k) {
            if (c.n !== '' && c.n.length > blen && a.slice(0, c.n.length) === c.n) { best = k; blen = c.n.length; }
          });
          if (best === -1) {
            // its first word, and its first two words joined ("Jet Black back")
            var aw = words(alt);
            if (aw.length) { wordTier(aw.length > 1 ? [aw[0], aw[0] + aw[1]] : [aw[0]]); }
          }
        }
      }
      // 3. the file name (images only)
      if (best === -1 && m.type !== 'video' && m.type !== 'external_video') {
        var f = fileBase(m.src);
        var fn = norm(f);
        if (fn !== '') {
          info.forEach(function (c, k) {
            if (c.n !== '' && c.n.length > blen && fn.indexOf(c.n) !== -1) { best = k; blen = c.n.length; }
          });
          if (best === -1) { wordTier(withPairs(words(f))); }
        }
      }
      return best === -1 ? '' : names[best];
    });
  }

  // The admin positions (0-based) shown for `colour`, in display order.
  function setFor(classes, types, colour) {
    var idx = [];
    for (var i = 0; i < classes.length; i++) { if (types[i] !== 'model') { idx.push(i); } }
    var want = str(colour).trim();
    var mine = want ? idx.filter(function (i) { return classes[i] === want; }) : [];
    var gen = idx.filter(function (i) { return !classes[i]; });
    if (mine.length) { return mine.concat(gen); }
    if (gen.length) { return gen; }
    return idx.length ? [idx[0]] : [];
  }

  // The admin position of the one image a card or the cart shows, or -1.
  function pickFor(classes, types, colour) {
    var want = str(colour).trim();
    var c1 = -1, g1 = -1, i1 = -1;
    for (var i = 0; i < classes.length; i++) {
      if (!isImage(types[i])) { continue; }
      if (i1 === -1) { i1 = i; }
      if (!classes[i]) { if (g1 === -1) { g1 = i; } } else if (want && classes[i] === want && c1 === -1) { c1 = i; }
    }
    return c1 !== -1 ? c1 : (g1 !== -1 ? g1 : i1);
  }

  /* ---- the gallery (browser only) -------------------------------------- */

  var WORDS = {
    photo: 'Photo [n] of [total]',
    enlarge: 'Enlarge photo [n] of [total]',
    close: 'Close',
    prev: 'Previous photo',
    next: 'Next photo',
    play: 'Play video',
    label: 'Photos',
    alt: '[title] in [colour]'
  };
  function fill(tpl, vars) {
    return str(tpl).replace(/\[(\w+)\]/g, function (whole, k) {
      return Object.prototype.hasOwnProperty.call(vars, k) ? str(vars[k]) : whole;
    });
  }
  function readWords(el) {
    var out = {};
    Object.keys(WORDS).forEach(function (k) { out[k] = WORDS[k]; });
    try {
      var given = JSON.parse(el.getAttribute('data-ug-gal-words') || '{}');
      Object.keys(given || {}).forEach(function (k) {
        if (typeof given[k] === 'string' && given[k].trim()) { out[k] = given[k]; }
      });
    } catch (e) { /* the English words stand */ }
    return out;
  }
  function qsa(el, sel) { return el ? Array.prototype.slice.call(el.querySelectorAll(sel)) : []; }
  function reducedMotion() {
    try { return !!(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; }
  }
  function isRtl(el) {
    try { return win.getComputedStyle(el).direction === 'rtl'; } catch (e) { return false; }
  }
  // The next frame (bound: an unbound requestAnimationFrame throws).
  function frame(fn) {
    if (win && typeof win.requestAnimationFrame === 'function') { return win.requestAnimationFrame(fn); }
    return win.setTimeout(fn, 16);
  }
  function dialogSupported() {
    return !!(win && win.HTMLDialogElement && typeof win.HTMLDialogElement.prototype.showModal === 'function');
  }
  // The largest candidate of a srcset (the lightbox shows the photo large).
  function largest(img) {
    var best = img.getAttribute('src') || '';
    var bw = 0;
    str(img.getAttribute('srcset')).split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var w = parseInt(bits[1], 10);
      if (bits[0] && w > bw) { bw = w; best = bits[0]; }
    });
    return best;
  }

  // Whether a click inside a large-view <img> lands on the picture itself.
  // The element fills its slide (upgrade-material.css 10.4); object-fit:
  // scale-down holds the picture whole, centred, never past its own pixels.
  // Not yet loaded: counted as the picture, so the view stays open.
  function onPicture(img, e) {
    var r = img.getBoundingClientRect();
    var nw = img.naturalWidth || 0;
    var nh = img.naturalHeight || 0;
    if (!nw || !nh || !r.width || !r.height || typeof e.clientX !== 'number') { return true; }
    var s = Math.min(1, r.width / nw, r.height / nh);
    var w = nw * s;
    var h = nh * s;
    var x0 = r.left + (r.width - w) / 2;
    var y0 = r.top + (r.height - h) / 2;
    return e.clientX >= x0 && e.clientX <= x0 + w && e.clientY >= y0 && e.clientY <= y0 + h;
  }

  function Gallery(rootEl) {
    this.root = rootEl;
    this.track = rootEl.querySelector('[data-ug-pdp-gallery-track]');
    this.thumbWrap = rootEl.querySelector('[data-ug-gal-thumbs]');
    this.words = readWords(rootEl);
    this.items = [];
    this.set = [];
    this.active = 0;
    this.box = null;
    this.collect();
    this.wire();
    var want = rootEl.getAttribute('data-ug-gal-want') || rootEl.getAttribute('data-ug-gal-colour') || '';
    this.apply(want, true);
  }

  Gallery.prototype.collect = function () {
    var byI = {};
    this.items = qsa(this.track, '[data-ug-gal-slide]').map(function (slide) {
      var it = {
        i: parseInt(slide.getAttribute('data-ug-gal-i'), 10),
        cls: slide.getAttribute('data-ug-gal-c') || '',
        type: slide.getAttribute('data-ug-gal-t') || 'image',
        slide: slide,
        thumb: null
      };
      byI[it.i] = it;
      return it;
    }).sort(function (a, b) { return a.i - b.i; });
    qsa(this.thumbWrap, '[data-ug-gal-thumb]').forEach(function (t) {
      var it = byI[parseInt(t.getAttribute('data-ug-gal-i'), 10)];
      if (it) { it.thumb = t; }
    });
  };

  Gallery.prototype.classes = function () { return this.items.map(function (it) { return it.cls; }); };
  Gallery.prototype.types = function () { return this.items.map(function (it) { return it.type; }); };
  Gallery.prototype.byAdmin = function (i) {
    for (var k = 0; k < this.items.length; k++) { if (this.items[k].i === i) { return this.items[k]; } }
    return null;
  };

  // Show the photos of `colour`. On the first call the server has already
  // printed this very set in this order, so nothing moves.
  Gallery.prototype.apply = function (colour, first) {
    var self = this;
    var positions = setFor(this.classes(), this.types(), colour).map(function (k) { return self.items[k].i; });
    var same = positions.length === this.set.length && positions.every(function (p, k) { return p === self.set[k]; });
    if (same && !first) { return; }
    this.colour = str(colour).trim();
    this.set = positions;
    var shown = {};
    positions.forEach(function (p) { shown[p] = true; });
    // DOM order = display order: this colour's set first, the rest after it, hidden.
    var order = positions.concat(this.items.map(function (it) { return it.i; }).filter(function (p) { return !shown[p]; }));
    order.forEach(function (p) {
      var it = self.byAdmin(p);
      if (!it) { return; }
      if (it.slide.parentNode === self.track) { self.track.appendChild(it.slide); }
      if (it.thumb && self.thumbWrap && it.thumb.parentNode === self.thumbWrap) { self.thumbWrap.appendChild(it.thumb); }
      it.slide.hidden = !shown[p];
      if (it.thumb) { it.thumb.hidden = !shown[p]; }
      if (!shown[p]) { self.pause(it); }
    });
    var total = positions.length;
    // "Photo 2 of 4" counts the photos only, the same way the large view
    // does (it shows photos only); a video's thumbnail keeps its own name,
    // "Play video: <alt>", printed with it. Check D6, 7 Oct 2026.
    var photos = positions.filter(function (p) { var x = self.byAdmin(p); return !!x && isImage(x.type); }).length;
    var pn = 0;
    positions.forEach(function (p, n) {
      var it = self.byAdmin(p);
      var photo = isImage(it.type);
      if (photo) { pn += 1; }
      var vars = { n: pn, total: photos };
      if (it.thumb) {
        if (photo) { it.thumb.setAttribute('aria-label', fill(self.words.photo, vars)); }
        it.thumb.setAttribute('data-index', String(n));
      }
      var zoom = it.slide.querySelector('[data-ug-gal-zoom]');
      if (zoom) {
        zoom.setAttribute('aria-label', fill(self.words.enlarge, vars));
        zoom.hidden = !dialogSupported();
      }
      // A video's poster is fetched only once its slide is on screen (a
      // hidden colour's poster is printed as data-ug-gal-poster). Check D7.
      var v = it.slide.querySelector('video');
      var later = v ? v.getAttribute('data-ug-gal-poster') : null;
      if (later && !v.getAttribute('poster')) {
        v.setAttribute('poster', later);
        v.removeAttribute('data-ug-gal-poster');
      }
    });
    if (this.thumbWrap) { this.thumbWrap.hidden = total < 2; }
    this.root.setAttribute('data-ug-gal-count', String(total));
    this.go(0, false);
  };

  Gallery.prototype.width = function () { return (this.track && this.track.clientWidth) || 0; };

  Gallery.prototype.go = function (n, smooth) {
    if (!this.track) { return; }
    var total = this.set.length;
    if (!total) { return; }
    n = Math.max(0, Math.min(total - 1, n | 0));
    var left = n * this.width() * (isRtl(this.track) ? -1 : 1);
    try {
      this.track.scrollTo({ left: left, behavior: (smooth && !reducedMotion()) ? 'smooth' : 'auto' });
    } catch (e) {
      this.track.scrollLeft = left;
    }
    this.mark(n);
  };

  Gallery.prototype.mark = function (n) {
    var self = this;
    var changed = n !== this.active;
    this.active = n;
    this.set.forEach(function (p, k) {
      var it = self.byAdmin(p);
      if (!it) { return; }
      if (it.thumb) {
        if (k === n) { it.thumb.setAttribute('aria-current', 'true'); } else { it.thumb.removeAttribute('aria-current'); }
      }
      if (k !== n) { self.pause(it); }
    });
    if (changed) { this.reveal(n); }
  };

  // Keeps the current thumbnail in view inside its own row or column,
  // without scrolling the page. 2.0 (13 Oct 2026): it is brought to the CENTRE
  // of the strip and the strip glides there (instant under reduced motion), so
  // the row follows the photo the customer swiped to instead of leaving it at
  // the edge. The offsets are in screen pixels, so this reads the same in
  // /ar, where the strip's scroll origin is on the right.
  Gallery.prototype.reveal = function (n) {
    var it = this.byAdmin(this.set[n]);
    var wrap = this.thumbWrap;
    if (!it || !it.thumb || !wrap || wrap.hidden) { return; }
    var tr = it.thumb.getBoundingClientRect();
    var wr = wrap.getBoundingClientRect();
    var dx = 0;
    var dy = 0;
    if (wrap.scrollWidth > wrap.clientWidth + 1) { dx = (tr.left + tr.width / 2) - (wr.left + wr.width / 2); }
    if (wrap.scrollHeight > wrap.clientHeight + 1) { dy = (tr.top + tr.height / 2) - (wr.top + wr.height / 2); }
    if (Math.abs(dx) < 1 && Math.abs(dy) < 1) { return; }
    try {
      wrap.scrollBy({ left: dx, top: dy, behavior: reducedMotion() ? 'auto' : 'smooth' });
    } catch (e) {
      wrap.scrollLeft += dx;
      wrap.scrollTop += dy;
    }
  };

  Gallery.prototype.pause = function (it) {
    var v = it && it.slide && it.slide.querySelector('video');
    if (v && typeof v.pause === 'function' && !v.paused) { try { v.pause(); } catch (e) { /* nothing to stop */ } }
  };

  // Starts the video of a slide: a Shopify video plays in place; a YouTube
  // or Vimeo video swaps its poster for the player.
  Gallery.prototype.play = function (it) {
    if (!it || !it.slide) { return; }
    var a = it.slide.querySelector('[data-ug-gal-embed]');
    if (a) { this.embed(a); return; }
    var v = it.slide.querySelector('video');
    if (!v || typeof v.play !== 'function') { return; }
    try {
      var p = v.play();
      if (p && typeof p.catch === 'function') { p.catch(function () { /* the customer can press play */ }); }
    } catch (e) { /* the customer can press play */ }
  };

  Gallery.prototype.wire = function () {
    var self = this;
    if (this.thumbWrap) {
      this.thumbWrap.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-ug-gal-thumb]') : null;
        if (!b || b.hidden) { return; }
        var at = parseInt(b.getAttribute('data-ug-gal-i'), 10);
        var it = self.byAdmin(at);
        if (it && (it.type === 'video' || it.type === 'external_video')) {
          // A video's thumbnail is named "Play video: ...": it shows the
          // video and starts it (straight there, so no slide passed on the
          // way pauses it). A YouTube or Vimeo player loads only now.
          self.go(self.set.indexOf(at), false);
          self.play(it);
          return;
        }
        self.go(self.set.indexOf(at), true);
      });
      this.thumbWrap.addEventListener('keydown', function (e) {
        var keys = { ArrowLeft: 1, ArrowRight: 1, ArrowUp: 1, ArrowDown: 1, Home: 1, End: 1 };
        if (!keys[e.key]) { return; }
        var forward = isRtl(self.thumbWrap) ? 'ArrowLeft' : 'ArrowRight';
        var back = forward === 'ArrowLeft' ? 'ArrowRight' : 'ArrowLeft';
        var n = self.active;
        if (e.key === forward || e.key === 'ArrowDown') { n += 1; } else if (e.key === back || e.key === 'ArrowUp') { n -= 1; } else if (e.key === 'Home') { n = 0; } else { n = self.set.length - 1; }
        n = Math.max(0, Math.min(self.set.length - 1, n));
        self.go(n, true);
        var it = self.byAdmin(self.set[n]);
        if (it && it.thumb) { it.thumb.focus(); }
        e.preventDefault();
      });
    }
    if (this.track) {
      var pending = false;
      this.track.addEventListener('scroll', function () {
        if (pending) { return; }
        pending = true;
        frame(function () {
          pending = false;
          var w = self.width();
          if (!w) { return; }
          var n = Math.round(Math.abs(self.track.scrollLeft) / w);
          if (n !== self.active && n >= 0 && n < self.set.length) { self.mark(n); }
        });
      }, { passive: true });
      this.track.addEventListener('click', function (e) {
        var t = e.target;
        var zoom = t && t.closest ? t.closest('[data-ug-gal-zoom]') : null;
        if (zoom) {
          var slide = zoom.closest('[data-ug-gal-slide]');
          self.open(parseInt(slide.getAttribute('data-ug-gal-i'), 10), zoom);
          return;
        }
        var embed = t && t.closest ? t.closest('[data-ug-gal-embed]') : null;
        if (embed) {
          e.preventDefault();
          self.embed(embed);
        }
      });
    }
    this.wireZoom();
    var resized = null;
    win.addEventListener('resize', function () {
      if (resized) { win.clearTimeout(resized); }
      resized = win.setTimeout(function () { self.go(self.active, false); }, 120);
    });
  };

  // A YouTube or Vimeo video: its player is loaded only now.
  Gallery.prototype.embed = function (a) {
    var url = a.getAttribute('data-ug-gal-embed');
    if (!url) { return; }
    var frame = win.document.createElement('iframe');
    frame.className = 'ug-gal__frame';
    frame.src = url;
    frame.title = a.getAttribute('aria-label') || this.words.play;
    frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('loading', 'eager');
    a.parentNode.replaceChild(frame, a);
  };

  /* ---- hover zoom (2.0, 13 Oct 2026) ---------------------------------------
     A mouse over a photo magnifies it about the pointer; a click still opens
     the large view. Fine pointers only ((hover: hover) and (pointer: fine)):
     a phone has its swipe and the large view (and pinch inside it), so nothing
     here runs there. Only `transform` moves (CSS .is-zooming, upgrade-material
     .css 10.3), the pointer position is two custom properties written once per
     frame. The first time a photo is hovered the browser is told to fetch its
     largest candidate (sizes = 1200px), so the magnified picture is sharp and
     not the 600 px one the page loaded; a photo that is small to begin with
     (data-ug-gal-small, the 360 px uploads) is never magnified, since that
     would only blur it. A video slide is left alone. */
  Gallery.prototype.wireZoom = function () {
    var fine = false;
    try { fine = !!(win.matchMedia && win.matchMedia('(hover: hover) and (pointer: fine)').matches); } catch (e) { fine = false; }
    if (!fine || !this.track) { return; }
    var cur = null;
    var queued = false;
    var px = 50;
    var py = 50;
    var paint = function () {
      queued = false;
      if (!cur) { return; }
      cur.style.setProperty('--zx', px + '%');
      cur.style.setProperty('--zy', py + '%');
    };
    var leave = function () {
      if (cur) { cur.classList.remove('is-zooming'); }
      cur = null;
    };
    this.track.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') { return; }
      var slide = e.target && e.target.closest ? e.target.closest('[data-ug-gal-slide]') : null;
      if (!slide || slide.hidden || slide.hasAttribute('data-ug-gal-small') || slide.getAttribute('data-ug-gal-t') !== 'image') { return; }
      var r = slide.getBoundingClientRect();
      if (!r.width || !r.height) { return; }
      px = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
      py = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
      if (cur !== slide) {
        leave();
        cur = slide;
        var img = slide.querySelector('.ug-gal__img');
        if (img && !img.hasAttribute('data-ug-gal-hi')) { img.setAttribute('data-ug-gal-hi', ''); img.sizes = '1200px'; }
        paint();
        slide.classList.add('is-zooming');
      }
      if (!queued) { queued = true; frame(paint); }
    });
    this.track.addEventListener('pointerleave', leave);
    this.track.addEventListener('scroll', leave, { passive: true });
  };

  /* ---- the large view ---------------------------------------------------- */

  Gallery.prototype.images = function () {
    var self = this;
    return this.set.map(function (p) { return self.byAdmin(p); }).filter(function (it) { return it && isImage(it.type) && it.slide.querySelector('img'); });
  };

  Gallery.prototype.buildBox = function () {
    var d = win.document;
    var w = this.words;
    var box = d.createElement('dialog');
    box.className = 'ug-gal__box';
    // 2.0 (D6): opts the box into its open/close motion (upgrade-material.css
    // 10.4); without the attribute it is shown and hidden as it always was.
    box.setAttribute('data-ug-anim', '');
    box.setAttribute('aria-label', w.label);
    box.innerHTML =
      '<div class="ug-gal__box-bar">' +
        '<p class="ug-gal__box-count" aria-live="polite"></p>' +
        '<button type="button" class="ug-gal__box-close" data-ug-gal-close></button>' +
      '</div>' +
      '<div class="ug-gal__box-track" data-ug-gal-box-track></div>' +
      '<button type="button" class="ug-gal__box-nav ug-gal__box-nav--prev" data-ug-gal-prev></button>' +
      '<button type="button" class="ug-gal__box-nav ug-gal__box-nav--next" data-ug-gal-next></button>';
    var close = box.querySelector('[data-ug-gal-close]');
    close.setAttribute('aria-label', w.close);
    close.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>';
    var prev = box.querySelector('[data-ug-gal-prev]');
    var next = box.querySelector('[data-ug-gal-next]');
    prev.setAttribute('aria-label', w.prev);
    next.setAttribute('aria-label', w.next);
    var chev = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M14.5 5.5L8 12l6.5 6.5" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    prev.innerHTML = chev;
    next.innerHTML = chev;
    d.body.appendChild(box);
    var self = this;
    close.addEventListener('click', function () { self.shut(); });
    // Escape: the browser's own close would cut the exit short, so it is
    // taken over and run through shut() (a second Escape closes at once).
    box.addEventListener('cancel', function (e) { e.preventDefault(); self.shut(); });
    prev.addEventListener('click', function () { self.boxGo(self.boxAt - 1, true); });
    next.addEventListener('click', function () { self.boxGo(self.boxAt + 1, true); });
    box.addEventListener('keydown', function (e) {
      var fwd = isRtl(box) ? 'ArrowLeft' : 'ArrowRight';
      var bwd = fwd === 'ArrowLeft' ? 'ArrowRight' : 'ArrowLeft';
      if (e.key === fwd) { self.boxGo(self.boxAt + 1, true); e.preventDefault(); } else if (e.key === bwd) { self.boxGo(self.boxAt - 1, true); e.preventDefault(); } else if (e.key === 'Home') { self.boxGo(0, true); e.preventDefault(); } else if (e.key === 'End') { self.boxGo(self.boxCount - 1, true); e.preventDefault(); }
    });
    // A tap or click outside the photo closes it: on the space around the
    // slide, or on the part of the large <img> the picture does not cover
    // (the element fills the slide; the picture is held whole inside it).
    // Check D4, 7 Oct 2026.
    box.addEventListener('click', function (e) {
      var t = e.target;
      if (t === box || (t && t.classList && t.classList.contains('ug-gal__box-slide'))) { self.shut(); return; }
      if (t && t.classList && t.classList.contains('ug-gal__box-img') && !onPicture(t, e)) { self.shut(); }
    });
    box.addEventListener('close', function () {
      win.clearTimeout(self._shutTimer);
      box.classList.remove('is-open');
      win.document.documentElement.classList.remove('ug-gal-open');
      // Back on the page, on the photo they were looking at, with focus on
      // that photo's own button (not the one the view was opened from,
      // which may now be out of view). Check D5, 7 Oct 2026.
      var it = self.boxItems && self.boxItems[self.boxAt];
      if (it) { self.go(self.set.indexOf(it.i), false); }
      var zoom = it && it.slide ? it.slide.querySelector('[data-ug-gal-zoom]') : null;
      var back = (zoom && !zoom.hidden && !it.slide.hidden) ? zoom : self.boxFrom;
      if (back && typeof back.focus === 'function') { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }
    });
    var bt = box.querySelector('[data-ug-gal-box-track]');
    var pending = false;
    bt.addEventListener('scroll', function () {
      if (pending) { return; }
      pending = true;
      frame(function () {
        pending = false;
        var wdt = bt.clientWidth;
        if (!wdt) { return; }
        var n = Math.round(Math.abs(bt.scrollLeft) / wdt);
        if (n !== self.boxAt) { self.boxMark(n); }
      });
    }, { passive: true });
    this.box = box;
    this.boxTrack = bt;
    return box;
  };

  Gallery.prototype.open = function (adminI, from) {
    if (!dialogSupported()) { return; }
    var box = this.box || this.buildBox();
    var items = this.images();
    if (!items.length) { return; }
    var d = win.document;
    var bt = this.boxTrack;
    bt.innerHTML = '';
    items.forEach(function (it) {
      var src = it.slide.querySelector('img');
      var fig = d.createElement('figure');
      fig.className = 'ug-gal__box-slide';
      var img = d.createElement('img');
      img.className = 'ug-gal__box-img';
      // 2.0 (D6): the figure shows a pale plate until its picture has loaded,
      // then the picture fades in (an error counts as loaded, so the alt text
      // shows instead of a plate for ever). A picture already in the cache is
      // marked at once, so it never flashes.
      var shown = function () { fig.classList.add('is-loaded'); };
      img.addEventListener('load', shown);
      img.addEventListener('error', shown);
      // only the photo that was opened is fetched at once; the others load
      // as the strip nears them (a 1200 px photo each, on mobile data)
      img.loading = it.i === adminI ? 'eager' : 'lazy';
      img.src = largest(src);
      img.alt = src.getAttribute('alt') || '';
      img.decoding = 'async';
      if (src.getAttribute('width')) { img.setAttribute('width', src.getAttribute('width')); }
      if (src.getAttribute('height')) { img.setAttribute('height', src.getAttribute('height')); }
      if (img.complete && img.naturalWidth) { shown(); }
      fig.appendChild(img);
      bt.appendChild(fig);
    });
    this.boxItems = items;
    this.boxCount = items.length;
    this.boxFrom = from || null;
    var at = 0;
    items.forEach(function (it, k) { if (it.i === adminI) { at = k; } });
    var single = items.length < 2;
    box.querySelector('[data-ug-gal-prev]').hidden = single;
    box.querySelector('[data-ug-gal-next]').hidden = single;
    d.documentElement.classList.add('ug-gal-open');
    win.clearTimeout(this._shutTimer);
    if (!box.open) { box.showModal(); }
    // 2.0 (D6): the first style is the closed look; one reflow later the box is
    // given .is-open, so it fades and settles in (scale .98 to 1) instead of
    // appearing. The exit is shut(), below.
    box.classList.remove('is-open');
    void box.offsetWidth;
    box.classList.add('is-open');
    this.boxAt = -1;
    this.boxGo(at, false);
    var close = box.querySelector('[data-ug-gal-close]');
    try { close.focus({ preventScroll: true }); } catch (e) { close.focus(); }
  };

  // The large view's way out (close button, a tap beside the photo, Escape):
  // it fades and settles back first, quicker than it came in (exit shorter
  // than enter), then the dialog is really closed, which returns focus to
  // the photo the customer was on (the 'close' handler in buildBox).
  Gallery.prototype.shut = function () {
    var box = this.box;
    if (!box || !box.open) { return; }
    win.clearTimeout(this._shutTimer);
    if (reducedMotion()) { box.close(); return; }
    box.classList.remove('is-open');
    this._shutTimer = win.setTimeout(function () {
      if (box.open && !box.classList.contains('is-open')) { box.close(); }
    }, 180);
  };

  Gallery.prototype.boxGo = function (n, smooth) {
    if (!this.box) { return; }
    n = Math.max(0, Math.min(this.boxCount - 1, n | 0));
    var bt = this.boxTrack;
    var left = n * bt.clientWidth * (isRtl(bt) ? -1 : 1);
    try { bt.scrollTo({ left: left, behavior: (smooth && !reducedMotion()) ? 'smooth' : 'auto' }); } catch (e) { bt.scrollLeft = left; }
    this.boxMark(n);
  };

  Gallery.prototype.boxMark = function (n) {
    this.boxAt = n;
    var box = this.box;
    box.querySelector('.ug-gal__box-count').textContent = fill(this.words.photo, { n: n + 1, total: this.boxCount });
    var prev = box.querySelector('[data-ug-gal-prev]');
    var next = box.querySelector('[data-ug-gal-next]');
    prev.disabled = n <= 0;
    next.disabled = n >= this.boxCount - 1;
  };

  /* ---- building the markup from /products/<handle>.js (/pages/device) --- */

  function esc(s) {
    return str(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  // A Shopify CDN image URL at another width.
  function sized(url, w) {
    var u = str(url);
    if (!u) { return ''; }
    if (/[?&]width=\d+/.test(u)) { return u.replace(/([?&])width=\d+/, '$1width=' + w); }
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  var SLIDE_WIDTHS = [400, 600, 800, 1000, 1200, 1600];
  var SLIDE_SIZES = '(min-width: 990px) 540px, (min-width: 750px) 46vw, 92vw';
  function embedUrl(m) {
    var id = encodeURIComponent(str(m.external_id));
    if (!id) { return ''; }
    if (m.host === 'youtube') { return 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1'; }
    if (m.host === 'vimeo') { return 'https://player.vimeo.com/video/' + id + '?autoplay=1'; }
    return '';
  }
  function watchUrl(m) {
    var id = encodeURIComponent(str(m.external_id));
    if (m.host === 'youtube') { return 'https://www.youtube.com/watch?v=' + id; }
    if (m.host === 'vimeo') { return 'https://vimeo.com/' + id; }
    return '';
  }

  // product: the /products/<handle>.js object. opts: { model, title, words }.
  // Writes the slides and thumbnails into the gallery and starts it.
  function fromProduct(galleryEl, product, opts) {
    opts = opts || {};
    if (!galleryEl || !product || !product.media || !product.media.length) { return null; }
    var track = galleryEl.querySelector('[data-ug-pdp-gallery-track]');
    if (!track) { return null; }
    var names = (product.options || []).map(function (o) { return str(o && typeof o === 'object' ? o.name : o).trim().toLowerCase(); });
    var ci = names.indexOf('colour');
    if (ci === -1) { ci = names.indexOf('color'); }
    var colours = [];
    if (ci !== -1) {
      var opt = product.options[ci];
      if (opt && typeof opt === 'object' && opt.values) { colours = opt.values.map(function (v) { return str(v).trim(); }); }
    }
    var media = product.media.map(function (m) {
      return { id: m.id, type: m.media_type, alt: m.alt, src: m.src || (m.preview_image && m.preview_image.src) || '' };
    });
    var vimgs = [];
    (product.variants || []).forEach(function (v) {
      var fm = v.featured_media;
      if (ci !== -1 && fm && fm.id != null) { vimgs.push({ mediaId: fm.id, colour: v['option' + (ci + 1)] }); }
    });
    var classes = classify(colours, media, vimgs);
    // The set of the colour the page opens on: its first photo is the one
    // loaded first (check D2), and only its video gets its poster now
    // (check D7); every other photo and poster waits until it is shown.
    var types = product.media.map(function (m) { return m.media_type || 'image'; });
    var open = setFor(classes, types, opts.colour);
    var shown = {};
    open.forEach(function (k) { shown[k] = true; });
    var eager = (open.length && isImage(types[open[0]])) ? open[0] : -1;
    if (opts.words) {
      // the section's own words (printed in the page's language) win; the script's only fill a gap
      var have = {};
      try { have = JSON.parse(galleryEl.getAttribute('data-ug-gal-words') || '{}') || {}; } catch (e) { have = {}; }
      Object.keys(opts.words).forEach(function (k) { if (!have[k] && typeof opts.words[k] === 'string') { have[k] = opts.words[k]; } });
      try { galleryEl.setAttribute('data-ug-gal-words', JSON.stringify(have)); } catch (e) { /* English */ }
    }
    var words = readWords(galleryEl);
    var title = str(opts.title || product.title);
    var model = str(opts.model || title);
    var slides = '';
    var thumbs = '';
    var n = 0;
    product.media.forEach(function (m, i) {
      var type = m.media_type || 'image';
      if (type === 'model') { return; }
      var cls = classes[i];
      var alt = str(m.alt).trim() || (cls ? fill(words.alt, { title: model, colour: cls }) : title);
      var pv = (m.preview_image && m.preview_image.src) || m.src || '';
      var w = (m.preview_image && m.preview_image.width) || m.width || 800;
      var h = (m.preview_image && m.preview_image.height) || m.height || 800;
      var body;
      if (type === 'video') {
        body = '<video class="ug-gal__video" controls playsinline preload="none" ' + (shown[i] ? 'poster' : 'data-ug-gal-poster') + '="' + esc(sized(pv, 1000)) + '" width="' + w + '" height="' + h + '">' +
          (m.sources || []).map(function (s) { return '<source src="' + esc(s.url) + '" type="' + esc(s.mime_type) + '">'; }).join('') + '</video>';
      } else if (type === 'external_video') {
        var e = embedUrl(m);
        body = '<a class="ug-gal__play" href="' + esc(watchUrl(m)) + '" target="_blank" rel="noopener" data-ug-gal-embed="' + esc(e) + '" aria-label="' + esc(words.play + ': ' + alt) + '">' +
          '<img class="ug-gal__img" src="' + esc(sized(pv, 1000)) + '" alt="" width="' + w + '" height="' + h + '" loading="lazy" decoding="async"><span class="ug-gal__play-icon" aria-hidden="true"></span></a>';
      } else {
        var src = m.src || pv;
        body = '<img class="ug-gal__img" src="' + esc(sized(src, 800)) + '" srcset="' + SLIDE_WIDTHS.map(function (x) { return esc(sized(src, x)) + ' ' + x + 'w'; }).join(', ') +
          '" sizes="' + SLIDE_SIZES + '" alt="' + esc(alt) + '" width="' + w + '" height="' + h + '"' + (i === eager ? ' loading="eager" fetchpriority="high"' : ' loading="lazy"') + ' decoding="async">' +
          '<button type="button" class="ug-gal__zoom" data-ug-gal-zoom hidden></button>';
      }
      slides += '<div class="ug-pdp__gallery-slide ug-pdp__gallery-slide--photo ug-gal__slide" data-ug-pdp-gallery-slide data-ug-gal-slide data-ug-gal-i="' + i +
        '" data-ug-gal-c="' + esc(cls) + '" data-ug-gal-t="' + esc(type) + '"' + (w < 700 ? ' data-ug-gal-small' : '') + '>' + body + '</div>';
      var vid = type === 'video' || type === 'external_video';
      thumbs += '<button type="button" class="ug-pdp__gallery-thumb ug-gal__thumb" data-ug-pdp-gallery-thumb data-ug-gal-thumb data-ug-gal-i="' + i + '" data-index="' + n + '"' + (vid ? ' aria-label="' + esc(words.play + ': ' + alt) + '"' : '') + '>' +
        '<img src="' + esc(sized(pv, 160)) + '" alt="" width="80" height="80" loading="lazy" decoding="async">' +
        (vid ? '<span class="ug-gal__thumb-play" aria-hidden="true"></span>' : '') + '</button>';
      n += 1;
    });
    if (!n) { return null; }
    track.innerHTML = slides;
    var thumbWrap = galleryEl.querySelector('[data-ug-pdp-gallery-thumbs]');
    if (thumbWrap) {
      thumbWrap.innerHTML = thumbs;
      thumbWrap.setAttribute('data-ug-gal-thumbs', '');
      thumbWrap.setAttribute('role', 'group');
      thumbWrap.setAttribute('aria-label', words.label);
      thumbWrap.className = 'ug-pdp__gallery-thumbs ug-gal__thumbs';
    }
    var dots = galleryEl.querySelector('[data-ug-pdp-gallery-dots]');
    if (dots) { dots.innerHTML = ''; dots.hidden = true; }
    galleryEl.classList.add('ug-gal');
    galleryEl.setAttribute('data-ug-gal', '');
    galleryEl.setAttribute('data-ug-pdp-gallery-source', 'shopify');
    if (opts.colour) { galleryEl.setAttribute('data-ug-gal-colour', str(opts.colour)); }
    galleryEl.__ugGallery = null;
    return start(galleryEl);
  }

  /* ---- start-up and the one call assets/upgrade-pdp.js makes ------------ */

  function start(el) {
    if (!el) { return null; }
    if (el.__ugGallery) { return el.__ugGallery; }
    try { el.__ugGallery = new Gallery(el); } catch (e) { el.__ugGallery = null; }
    return el.__ugGallery;
  }
  function boot() {
    if (!win || !win.document) { return; }
    var go = function () { qsa(win.document, '[data-ug-gal]').forEach(start); };
    if (win.document.readyState === 'loading') { win.document.addEventListener('DOMContentLoaded', go); } else { go(); }
  }
  // The colour on screen changed (or was first known): show its photos.
  function setColour(el, colour) {
    if (!el) { return; }
    el.setAttribute('data-ug-gal-want', str(colour));
    var g = el.__ugGallery || (el.hasAttribute('data-ug-gal') ? start(el) : null);
    if (g) { g.apply(colour, false); }
  }

  return {
    classify: classify,
    setFor: setFor,
    pickFor: pickFor,
    norm: norm,
    words: words,
    fileBase: fileBase,
    fill: fill,
    fromProduct: fromProduct,
    setColour: setColour,
    start: start,
    boot: boot,
    WORDS: WORDS
  };
});
